<template>
  <div  :class="selected_report?.story_board || print_mode ? 'px-print' : 'container'">
    <template v-if="!selected_report?.story_board">
      <h2 class="mt-5">SASB Index</h2>
    </template>

    <template v-if="sasb_contents.length === 0">
      <h3 class="py-3 fw-600 text-center">
        <b-skeleton-img no-aspect height="30px" width="40%"></b-skeleton-img>
      </h3>

      <b-row >
        <template v-if="show_table_header">
            <b-col cols="3">
              {{ lang !== 'ENG' ? '보고 지표' : 'Disclosures' }}
            </b-col>
            <b-col cols="3">
              {{ lang != 'ENG' ? '보고 내용' : 'Disclosure Contents' }}
            </b-col>
            <b-col cols="6" class="text-right">
              <div>
                <b-icon icon="table" class="mr-1" />
                {{ lang != 'ENG' ? '데이터 테이블' : 'Data Tables' }}
                <b-icon icon="file-earmark-text" class="ml-3 mr-1" />
                {{ lang != 'ENG' ? '문서' : 'Files' }}
                <b-icon icon="link-45deg" class="ml-3 mr-1" />
                {{ lang != 'ENG' ? '외부 링크' : 'URLs' }}
                <b-icon icon="briefcase" class="ml-3 mr-1" />
                {{ lang != 'ENG' ? '비즈니스 사례' : 'Business Cases' }}
              </div>
            </b-col>
        </template>

        <div class="mb-2 border-0">
          <div class="d-flex">
            <div class="flex-grow-1 py-1 pl-1" :style="main_color_sub">
              <span class="fw-600 f-140">
                <b-skeleton animation="wave" width="20%"></b-skeleton>
              </span>
            </div>
          </div>
          <div class="d-flex">
            <div class="flex-grow-0 pr-3 d-flex flex-column" style="width: 30%">
              <div class="fw-600 f-140">
                <b-skeleton animation="wave" width="30%"></b-skeleton>
                <b-skeleton animation="wave" width="15%"></b-skeleton>
              </div>
            </div>
            <div class="flex-grow-1" style="width: 70%">
              <b-skeleton animation="wave" width="85%"></b-skeleton>
              <b-skeleton animation="wave" width="55%"></b-skeleton>
              <b-skeleton animation="wave" width="70%"></b-skeleton>
            </div>
          </div>
          <div class="d-flex">
            <div class="flex-grow-0 pr-3 d-flex flex-column" style="width: 30%">
              <div class="fw-600 f-140">
                <b-skeleton animation="wave" width="30%"></b-skeleton>
                <b-skeleton animation="wave" width="15%"></b-skeleton>
              </div>
            </div>
            <div class="flex-grow-1" style="width: 70%">
              <b-skeleton animation="wave" width="55%"></b-skeleton>
              <b-skeleton animation="wave" width="35%"></b-skeleton>
              <b-skeleton animation="wave" width="70%"></b-skeleton>
            </div>
          </div>
        </div>
      </b-row>
    </template>

    <div v-for="(industry_key, industry_idx) in Object.keys(sasb_contents)" :key="industry_idx">
      <div v-if="Object.keys(sasb_contents[industry_key]['sustainability_metrics']).length > 0">
        <h3 :id="!print_mode ? 'rp' + industry_key : ''"  class="py-3" :class="{
          'page-no-break-before':
            print_mode &&
            selected_report?.story_board &&
            industry_idx === 0,
          'page-break-before':
            print_mode &&
            selected_report?.story_board &&
            industry_idx > 0
        }">
          {{ industry_key }}.
          {{
            lang === 'KOR'
              ? sasb_contents[industry_key]['industry_name']
              : sasb_contents[industry_key]['industry_name_e']
          }}
        </h3>

        <h5>
          <span v-if="lang === 'KOR'"> 지속가능성 공시 주제 및 지표 </span>
          <span v-else> Sustainability Disclosure Topics & Metrics </span>
        </h5>

        <div class="mb-5">
          <template v-if="show_table_header">
            <b-row>
              <b-col cols="3">
                {{ lang !== 'ENG' ? '보고 지표' : 'Disclosures' }}
                <header-anchor :active_code="industry_key" :print_mode="print_mode" />
              </b-col>
              <b-col cols="3">
                {{ lang != 'ENG' ? '보고 내용' : 'Disclosure Contents' }}
              </b-col>
              <b-col cols="6" class="text-right">
                  <b-icon icon="table" class="mr-1" />
                  {{ lang != 'ENG' ? '데이터 테이블' : 'Data Tables' }}
                  <b-icon icon="file-earmark-text" class="ml-3 mr-1" />
                  {{ lang != 'ENG' ? '문서' : 'Files' }}
                  <b-icon icon="link-45deg" class="ml-3 mr-1" />
                  {{ lang != 'ENG' ? '외부 링크' : 'URLs' }}
                  <b-icon icon="briefcase" class="ml-3 mr-1" />
                  {{ lang != 'ENG' ? '비즈니스 사례' : 'Business Cases' }}
              </b-col>
            </b-row>
          </template>

          <div v-for="(topic_key, topic_idx) in Object.keys(
            sasb_contents[industry_key]['sustainability_metrics']
          )" :key="topic_idx" class="mb-5 border-0">
            <div class="d-flex">
              <div class="flex-grow-1 py-1 pl-1" :style="main_color_sub">
                <span :id="!print_mode ? 'trp' + industry_key + topic_idx : ''" class="fw-600 f-140">
                  {{ topic_idx + 1 }}.
                  {{
                    lang !== 'ENG'
                      ? sasb_contents[industry_key]['sustainability_metrics'][topic_key][
                      'topic_name'
                      ]
                      : sasb_contents[industry_key]['sustainability_metrics'][topic_key][
                      'topic_name_e'
                      ]
                  }}
                </span>
                <span class="gray-500 f-90 fw-400 ml-1">
                  {{
                    sasb_contents[industry_key]['sustainability_metrics'][topic_key]['topic_name_e']
                  }}
                </span>
              </div>
            </div>

            <div v-for="disclosure in sasb_contents[industry_key]['sustainability_metrics'][topic_key][
              'children'
            ]" :key="disclosure.disclosure_id" :id="`w${disclosure.indicator_code}`" class="d-flex py-4 border-bottom">
              <div class="col-3">
                <div class="fw-500">{{ disclosure.indicator_code }}</div>
                <div class="fw-300">
                  <p v-html="lang === 'KOR'
                    ? disclosure.metric.replace(/\((\d+)\)/g, '<br>($1)')
                    : disclosure.metric_e.replace(/\((\d+)\)/g, '<br>($1)')
                    "></p>
                </div>
              </div>
              <div class="col-9">
                <p v-if="lang === 'KOR' && disclosure.direct_report" class="page-no-break-inside" style="word-wrap: break-word; white-space: pre-line;">
                  <span v-html="disclosure.direct_report"></span>
                </p>
                <p v-else-if="lang !== 'KOR' &&(disclosure.direct_report_em || disclosure.direct_report_ea)" class="page-no-break-inside" style="word-wrap: break-word; white-space: pre-line;">
                  <span v-html="disclosure.direct_report_em
                  ? disclosure.direct_report_em
                  : disclosure.direct_report_ea
                  " ></span>
                </p>
                <!-- data_tables 넣을자리 -->
                <div v-for="data_table_id in disclosure.data_tables" :key="'data_table_' + data_table_id">
                  <data-table :table_mode="table_mode" :data_table_id="data_table_id" :modal_table="modal_table"
                    :lazy_load="false" :table_style="table_style" :show_table_line="show_table_line"
                    :show_table_outline="show_table_outline" :table_header_color="table_header_color"
                    :table_header_font_color="table_header_font_color" />
                </div>

                <!-- documents 넣을자리 -->
                <div class="d-flex flex-column">
                  <span v-for="document_id in disclosure.documents" :key="'document_' + document_id">
                    <document :document_id="document_id" :lazy_load="false" />
                  </span>
                </div>

                <!-- business_cases 넣을자리 -->
                <div class="d-flex flex-column">
                  <span v-for="business_case_id in disclosure.business_cases"
                    :key="'business_case_' + business_case_id">
                    <business-case :business_case_id="business_case_id" :lazy_load="false"
                      :business_case_mode="business_case_mode" />
                  </span>
                </div>
                <span v-for="chart_id in disclosure.charts" :key="'chart_' + chart_id">
                  <ChartCanvas v-if="chart_id !== ''" :chart_id="chart_id" :print_mode="print_mode"
                    :key="`chart_${chart_id}`" :viewer_mode="true" class="mb-5" />
                </span>
              </div>
            </div>
          </div>
        </div>

        <h5 v-if="sasb_contents[industry_key]['activity_metrics'].length > 0">
          <span v-if="lang === 'KOR'"> 활동 지표 </span>
          <span v-else> Activity Metrics </span>
        </h5>

        <div v-if="sasb_contents[industry_key]['activity_metrics'].length > 0" class="disclosure-table lg mb-5">
          <template v-if="show_table_header">
            <b-row>
              <b-col cols="3">
                {{ lang !== 'ENG' ? '보고 지표' : 'Disclosures' }}
                <header-anchor :active_code="industry_key" :print_mode="print_mode" />
              </b-col>
              <b-col cols="3">
                {{ lang != 'ENG' ? '보고 내용' : 'Disclosure Contents' }}
              </b-col>
              <b-col cols="6" class="text-right">
                  <b-icon icon="table" class="mr-1" />
                  {{ lang != 'ENG' ? '데이터 테이블' : 'Data Tables' }}
                  <b-icon icon="file-earmark-text" class="ml-3 mr-1" />
                  {{ lang != 'ENG' ? '문서' : 'Files' }}
                  <b-icon icon="link-45deg" class="ml-3 mr-1" />
                  {{ lang != 'ENG' ? '외부 링크' : 'URLs' }}
                  <b-icon icon="briefcase" class="ml-3 mr-1" />
                  {{ lang != 'ENG' ? '비즈니스 사례' : 'Business Cases' }}
              </b-col>
            </b-row>
          </template>

          <div v-for="(disclosure, disclosure_idx) in sasb_contents[industry_key]['activity_metrics']"
            :id="'rp' + disclosure_idx" :key="disclosure_idx" class="mb-5 border-0">
            <div class="d-flex">
              <div class="flex-grow-1 py-1 pl-1" :style="main_color_sub">
                <span class="fw-600 f-140">  {{ disclosure_idx + 1 }}. </span>
                <span class="gray-500 f-90 fw-400 ml-1"> </span>
              </div>
            </div>

            <div class="d-flex py-4 border-bottom">
              <div class="col-3">
                <div class="fw-500">{{ disclosure.indicator_code }}</div>

                <p class="pb-3">{{ lang === 'KOR' ? disclosure.topic : disclosure.topic_e }}</p>
                <div class="fw-300 italic">
                  <p v-html="lang === 'KOR'
                    ? disclosure.metric.replace(/\((\d+)\)/g, '<br>($1)')
                    : disclosure.metric_e.replace(/\((\d+)\)/g, '<br>($1)')
                    "></p>
                </div>
              </div>
              <div class="col-9">
                <p v-if="lang === 'KOR' && disclosure.direct_report" class="page-no-break-inside" style="word-wrap: break-word; white-space: pre-line;">
                  <span v-html="disclosure.direct_report"></span>
                </p>
                <p v-else-if="lang !== 'KOR' && (disclosure.direct_report_em || disclosure.direct_report_ea)" class="page-no-break-inside" style="word-wrap: break-word; white-space: pre-line;">
                  <span v-html="disclosure.direct_report_em
                  ? disclosure.direct_report_em
                  : disclosure.direct_report_ea
                  " ></span>
                </p>

                <!-- data_tables 넣을자리 -->
                <div v-for="data_table_id in disclosure.data_tables" :key="'data_table_' + data_table_id">
                  <data-table :table_mode="table_mode" :data_table_id="data_table_id" :modal_table="modal_table"
                    :lazy_load="false" :table_style="table_style" :show_table_line="show_table_line"
                    :show_table_outline="show_table_outline" :table_header_color="table_header_color"
                    :table_header_font_color="table_header_font_color" />
                </div>

                <!-- documents 넣을자리 -->
                <div>
                  <span v-for="document_id in disclosure.documents" :key="'document_' + document_id">
                    <document :document_id="document_id" :lazy_load="false" />
                  </span>
                </div>

                <!-- business_cases 넣을자리 -->
                <span v-for="business_case_id in disclosure.business_cases" :key="'business_case_' + business_case_id">
                  <business-case :business_case_id="business_case_id"
                    :business_case_mode="business_case_mode" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import DataTable from './DataTable.vue';
import Document from './Document.vue';
import BusinessCase from './BusinessCase.vue';
import HeaderAnchor from './HeaderAnchor';
import { nan_table } from '@/components/util';
import ChartCanvas from '@/components/writing_report/chart_subs/ChartCanvas.vue';
import { gri_mixin } from '@/components/writing_report/write_report_subs/gri_mixin.js'

export default {
  name: 'SASBTable',
  mixins: [gri_mixin],
  components: {
    DataTable,
    Document,
    BusinessCase,
    HeaderAnchor,
    ChartCanvas,
  },
  data() {
    return {
      show_data_table: {},
      show_business_case: {},
      low_height: false,
      selected_indicator: null,
      show_table_header: true,
      nan_table,
    };
  },
  props: {
    modal_table: { type: Boolean, default: false },
    reload: { type: Boolean, default: false },
    print_mode: { type: Boolean, default: false },
    business_case_mode: { type: String, default: 'accordion' },
    table_mode: { type: String, default: 'accordion' },
    material_style_option: { type: String, default: 'fill' },

    table_style: { type: String, default: 'basic_table' },
    show_table_line: { type: Boolean, default: true },
    show_table_outline: { type: Boolean, default: false },
    table_header_color: { type: String, default: '#dedede' },
    table_header_font_color: { type: String, default: '#fffff' },
  },
  computed: {
    ...mapState('report_contents', ['sasb_contents']),
    ...mapState('report_list', ['lang', 'view_mode']),
    ...mapGetters('report_list', ['current_report_code', 'selected_report']),
    main_color() {
      return `color:` + this.selected_report.main_color;
    },
    main_color_sub() {
      if (this.material_style_option === 'fill') {
        return `background-color: ${this.selected_report.main_color}; color: white; border: 1px solid white; `;
      } else if (this.material_style_option === 'outline') {
        return (
          `color:` +
          this.selected_report.main_color +
          `; border-top: 1px solid ` +
          this.selected_report.main_color +
          `!important` +
          `; border-bottom: 1px solid ` +
          this.selected_report.main_color
        );
      } else {
        return `background-color: white; border-left: 3px solid ${this.selected_report.main_color}; border-bottom: 1px solid ${this.selected_report.sub_color}; border-top: 0px; border-right: 0px;`;
      }
    },
    main_bg_color() {
      if (this.selected_report) {
        return `background-color:` + this.selected_report.main_color;
      } else return `background-color: #494949`;
    },
  },
  watch: {},
  methods: {
    ...mapActions('report_contents', ['fetchSelectedSasb']),
    navAnchor(event, anchor) {
      event.preventDefault();
      if (anchor && document.querySelector('#w' + anchor)) {
        let elem = document.querySelector('#w' + anchor);
        if (elem) {
          elem.scrollIntoView({ behavior: 'smooth' });
        }
      }
    },
  },
  mounted() {
    this.fetchSelectedSasb(this.current_report_code);
  },
  created() {
  },
};
</script>
